import { isMobile, removeUndefineds} from '.';
import { getResolution } from '../state/settings/renderDimensions';
import Video from 'twilio-video';

export default function generateConnectionOptions({ settings, isDynamicSettings }) {    
    // See: https://media.twiliocdn.com/sdk/js/video/releases/2.0.0/docs/global.html#ConnectOptions
    // for available connection options.
    if (!isDynamicSettings) {
        const connectionOptions = {
            // Bandwidth Profile, Dominant Speaker, and Network Quality
            // features are only available in Small Group or Group Rooms.
            // Please set "Room Type" to "Group" or "Small Group" in your
            // Twilio Console: https://www.twilio.com/console/video/configure

            ...(settings.bandwidthprofile === "on" && {
                bandwidthProfile: {
                    video: {
                        ...(settings.bandwidthProfileMode && { mode: settings.bandwidthProfileMode }),
                        ...(settings.dominantSpeakerPriority && { dominantSpeakerPriority: settings.dominantSpeakerPriority }),
                        renderDimensions: {
                            low: getResolution(settings.renderDimensionLow ? settings.renderDimensionLow : "low"),
                            standard: getResolution(settings.renderDimensionStandard ? settings.renderDimensionStandard : "960p"),
                            high: getResolution(settings.renderDimensionHigh ? settings.renderDimensionHigh : "wide1080p")
                        }
                    }
                }
            }),
            dominantSpeaker: Boolean(settings.dominantSpeaker),
            networkQuality: settings.networkQuality ? { local: Number(settings.networkQuality.local), remote: Number(settings.networkQuality.remote) } : { local: 1, remote: 1 },

            // VP8 simulcast enables the media server in a Small Group or Group Room
            // to adapt your encoded video quality for each RemoteParticipant based on
            // their individual bandwidth constraints. This has no effect if you are
            // using Peer-to-Peer Rooms.
            ...(settings.preferredVideoCodecs && { preferredVideoCodecs: settings.preferredVideoCodecs }),
            ...(settings.logLevel && Video && !Video.Logger && { logLevel: settings.logLevel })
        };

        if (connectionOptions && settings) {
            if (settings.enableDscp) {
                connectionOptions.enableDscp = Boolean(settings.enableDscp);
            }
            if (settings.maxAudioBitrate) {
                //If need set it to "16000".
                connectionOptions.maxAudioBitrate = Number(settings.maxAudioBitrate);
            }
            if (connectionOptions.bandwidthProfile && connectionOptions.bandwidthProfile.video) {
                if (isMobile && settings.maxTracksForMobile) {
                    //For mobile maxTracks : 5
                    connectionOptions.bandwidthProfile.video.maxTracks = Number(settings.maxTracksForMobile);
                } else {
                    //For Web maxTracks : 10
                    if (settings.maxTracks) {
                        connectionOptions.bandwidthProfile.video.maxTracks = Number(settings.maxTracks);
                    }
                }
                if (settings.trackSwitchOffMode) {
                    connectionOptions.bandwidthProfile.video.trackSwitchOffMode = settings.trackSwitchOffMode;
                }
                // For mobile browsers, limit the maximum incoming video bitrate to 2.5 Mbps and this is option value and reading it from app config.
                if (isMobile && settings.maxSubscriptionBitrateForMobile) {
                    //If need set it to 2500000.
                    connectionOptions.bandwidthProfile.video.maxSubscriptionBitrate = Number(settings.maxSubscriptionBitrateForMobile);
                }
            }
            if (settings.region) {
                connectionOptions.region = settings.region;
            }
        }

        // Here we remove any 'undefined' values. The twilio-video SDK will only use defaults
        // when no value is passed for an option. It will throw an error when 'undefined' is passed.
        return removeUndefineds(connectionOptions);
    }
    else {        
        return removeUndefineds(settings);
    }
}

